import type { AppState } from '@store/types'
import { useSelector } from 'react-redux'

import { useArtboardMode, useScaleZoom } from '@/hooks'

export const useZoomMenu = () => {
  const arrowsHide = useSelector<AppState, boolean>(
    ({ canvas }) => canvas.arrow.hideArrows
  )
  const { zoom } = useScaleZoom()

  const { simpleView } = useArtboardMode()

  const showIndicator = arrowsHide || simpleView

  const btnText = `${zoom}%`

  return {
    btnText,
    showIndicator,
  }
}
